import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Stack, Typography } from '@mui/material';
import { DeviceControlContext } from '../../DeviceControlContext';
import { useContext } from 'react';
import { standardOutlinedStackProps, standardStackLabelProps } from './cosmetics';
export const BinaryControl = ({ state, dispatch, stateKey: key, label, maxWidth = '42ch', reported }) => {
    const { valueSettings, payloadRequestObject, validationMap } = state;
    const { state: DeviceControlContextState, dispatch: DeviceControlDispatch } = useContext(DeviceControlContext);
    const { rangeLimits, resolvedDownlinkAttributes, correspondingUplinkAttributeMap } = DeviceControlContextState;
    const subRangeLimits = rangeLimits?.[key];
    const mapValidation = validationMap[key] ?? {};
    const correspondingUplinkKey = correspondingUplinkAttributeMap?.[key] ?? key;
    const rawReportedValue = reported?.[correspondingUplinkKey];
    if (!valueSettings[key]) {
        return _jsx(Typography, { children: `Can't find key ${key}` });
    }
    else {
        const { include, value } = valueSettings[key];
        return (_jsxs(Stack, { ...standardOutlinedStackProps, position: 'relative', paddingBlock: 1.5, gap: 1, maxWidth, children: [_jsx(Typography, { ...standardStackLabelProps, children: `${label}` }), _jsx(Checkbox, { checked: include,
                    sx: { padding: 0 },
                    onClick: () => {
                        dispatch({ type: 'TogglePresence', update: { key } });
                    } }), _jsx(Typography, { component: "span", sx: { opacity: 0.6, fontStyle: 'italic' }, children: "(Select)" })] }));
    }
};
